var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackDownloadIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.33268 1.3335C3.41221 1.3335 2.66602 2.07969 2.66602 3.00016V13.0002C2.66602 13.9206 3.41221 14.6668 4.33268 14.6668H10.9993C11.9198 14.6668 12.666 13.9206 12.666 13.0002V5.84534C12.666 5.40331 12.4904 4.97939 12.1779 4.66683L9.33268 1.82165C9.02012 1.50909 8.5962 1.3335 8.15417 1.3335H4.33268ZM8.49935 6.3335C8.49935 5.87326 8.12625 5.50016 7.66602 5.50016C7.20578 5.50016 6.83268 5.87326 6.83268 6.3335V9.32165L5.75527 8.24424C5.42983 7.9188 4.9022 7.9188 4.57676 8.24424C4.25132 8.56968 4.25132 9.09731 4.57676 9.42275L7.07676 11.9228C7.4022 12.2482 7.92983 12.2482 8.25527 11.9228L10.7553 9.42275C11.0807 9.09731 11.0807 8.56968 10.7553 8.24424C10.4298 7.9188 9.9022 7.9188 9.57676 8.24424L8.49935 9.32165V6.3335Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackDownloadIcon);
export default __webpack_public_path__ + "static/media/black-download-icon.c4d4c1abf3f0c287180129bf863ee790.svg";
export { ForwardRef as ReactComponent };